var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingInvites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.5625C18.5383 0.5625 13.2812 5.81953 13.2812 12.2812V15.4062C13.2812 21.868 18.5383 27.125 25 27.125C31.4617 27.125 36.7188 21.868 36.7188 15.4062V12.2812C36.7188 5.81953 31.4617 0.5625 25 0.5625Z",
    fill: "#02BD04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8438 28.6875C34.6664 28.6875 30.4688 32.8852 30.4688 38.0625C30.4688 43.2398 34.6664 47.4375 39.8438 47.4375C45.0211 47.4375 49.2188 43.2398 49.2188 38.0625C49.2188 32.8852 45.0211 28.6875 39.8438 28.6875ZM43.75 38.8438H40.625V41.9688C40.625 42.4 40.275 42.75 39.8438 42.75C39.4125 42.75 39.0625 42.4 39.0625 41.9688V38.8438H35.9375C35.5062 38.8438 35.1562 38.4937 35.1562 38.0625C35.1562 37.6313 35.5062 37.2812 35.9375 37.2812H39.0625V34.1562C39.0625 33.725 39.4125 33.375 39.8438 33.375C40.275 33.375 40.625 33.725 40.625 34.1562V37.2812H43.75C44.1812 37.2812 44.5312 37.6313 44.5312 38.0625C44.5312 38.4937 44.1812 38.8438 43.75 38.8438Z",
    fill: "#02BD04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9062 38.0625C28.9062 35.7367 29.6375 33.5852 30.875 31.8125H15.625C7.43984 31.8125 0.78125 38.4711 0.78125 46.6562C0.78125 47.0883 1.13047 47.4375 1.5625 47.4375H34.2313C31.0453 45.5258 28.9062 42.0484 28.9062 38.0625Z",
    fill: "#02BD04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingInvites);
export default __webpack_public_path__ + "static/media/pending-invites.786ed549d92e19c206b8066df77c4cad.svg";
export { ForwardRef as ReactComponent };